import axios from "axios";
import * as actionType from "../../../constant/actionType";

const normalizeIds = (collection = [], key) => {
  if (!Array.isArray(collection)) return [];

  return collection
    .map((item) => {
      if (item == null) return null;
      if (typeof item === "number") return item;
      if (typeof item === "string" && item.trim() !== "") {
        const numeric = Number(item);
        return Number.isFinite(numeric) ? numeric : null;
      }
      if (typeof item === "object" && key && item[key] != null) {
        const numeric = Number(item[key]);
        return Number.isFinite(numeric) ? numeric : null;
      }
      return null;
    })
    .filter((value) => Number.isFinite(value));
};

const GenerateProviderWorkerDocsReportFunction = (apiData) => async (dispatch) => {
  try {
    const providerOrgIds = normalizeIds(apiData?.provider_org_ids, "provider_org_id");
    const clientOrgIds = normalizeIds(apiData?.client_org_ids, "organisation_id");
    const workerIds = normalizeIds(apiData?.worker_ids);
    const documentIds = normalizeIds(apiData?.document_ids);

    const isClientPortal = apiData?.portalType === "clientPortal";
    const url = isClientPortal
      ? `${actionType.environment_url}/api/client/TriggerProviderWorkerDocsReport`
      : `${actionType.environment_url}/api/admin/TriggerProviderWorkerDocsReport`;

    const { portalType, ...restData } = apiData;

    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
      },
      url: url,
      data: {
        ...restData,
        provider_org_ids: providerOrgIds,
        client_org_ids: clientOrgIds,
        worker_ids: workerIds,
        document_ids: documentIds,
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export { GenerateProviderWorkerDocsReportFunction };

